import { FC } from 'react';
import { useSearchParams } from 'react-router-dom';
import { formatDate } from 'src/utils/date-util';

import useIssueTasksByIds from 'src/hooks/useIssueTasksByIds';
import useStoreIssuesByIds from 'src/hooks/useStoreIssuesByIds';

import EmptyList from 'src/components/atoms/EmptyList/EmptyList';
import IssueTaskItem from 'src/components/atoms/IssueTaskItem/IssueTaskItem';
import StoreIssueItem from 'src/components/atoms/StoreIssueItem/StoreIssueItem';
import TopNavigationBar from 'src/components/atoms/TopNavigationBar/TopNavigationBar';

const StoreIssueDetail: FC = () => {
  const [searchParams] = useSearchParams();
  const issueIds = searchParams.getAll('issue-id');
  const taskIds = searchParams.getAll('task-id');
  const { storeIssues, storeIssuesLoading } = useStoreIssuesByIds(issueIds.length > 0 ? issueIds : null);
  const { issueTasks, issueTasksLoading } = useIssueTasksByIds(taskIds.length > 0 ? taskIds : null);

  const title =
    storeIssues && storeIssues.length > 0
      ? formatDate(storeIssues[0].date, 'L월 d일 (EEEEEE)')
      : issueTasks && issueTasks.length > 0 && issueTasks[0].targetDate
        ? formatDate(issueTasks[0].targetDate, 'L월 d일 (EEEEEE)')
        : '이슈 상세';

  const isEmpty = !storeIssuesLoading && !issueTasksLoading && storeIssues === undefined && issueTasks === undefined;

  return (
    <div>
      <TopNavigationBar title={title} leftButton />
      {isEmpty ? (
        <EmptyList message='이슈 정보를 불러오지 못했습니다.' />
      ) : (
        <div>
          {storeIssues && storeIssues.length > 0 && (
            <>
              <p style={{ padding: '10px 30px', color: 'var(--orange400)' }}>※ 특이사항</p>
              {storeIssues?.map((storeIssue) => {
                return <StoreIssueItem key={storeIssue._id} storeIssue={storeIssue} />;
              })}
              <p
                style={{
                  padding: '10px 30px',
                  color: 'var(--gray600)',
                }}>
                안내된 내용은 다음 정산에 포함됩니다.
              </p>
            </>
          )}
          {issueTasks && issueTasks.length > 0 && (
            <>
              <p style={{ padding: '10px 30px', color: 'var(--orange400)' }}>※ 이슈사항</p>
              {issueTasks?.map((issueTask) => {
                return <IssueTaskItem key={issueTask._id} issueTask={issueTask} />;
              })}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default StoreIssueDetail;
